import { render, staticRenderFns } from "./EditSelectBorrow.vue?vue&type=template&id=deb66ed8&scoped=true&"
import script from "./EditSelectBorrow.vue?vue&type=script&lang=js&"
export * from "./EditSelectBorrow.vue?vue&type=script&lang=js&"
import style0 from "./EditSelectBorrow.vue?vue&type=style&index=0&id=deb66ed8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb66ed8",
  null
  
)

export default component.exports